import type { DataSourceRequestState } from "@progress/kendo-data-query";
import {
    Grid
} from "@progress/kendo-react-grid";
import type {
    GridDataStateChangeEvent,
    GridPageChangeEvent,
    GridProps,
    GridSortChangeEvent
} from "@progress/kendo-react-grid";
import React, { useState } from "react";

export interface GridWithStateProps extends GridProps {
    initialState?: Partial<DataSourceRequestState>;
    children?: React.ReactNode;
}

export const AppGrid: React.FC<GridWithStateProps> = ({
    initialState,
    children,
    ...gridProps
}) => {
    const [dataState, setDataState] = useState<DataSourceRequestState>({
        skip: 0,
        take: 20,
        ...initialState
    });

    const handleSortChange = (e: GridSortChangeEvent) => {
        setDataState(prev => ({
            ...prev,
            sort: e.sort
        }));
        gridProps.onSortChange?.(e);
    };

    const handlePageChange = (e: GridPageChangeEvent) => {
        setDataState(prev => ({
            ...prev,
            skip: e.page.skip,
            take: e.page.take
        }));
        gridProps.onPageChange?.(e);
    };

    const handleDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState({
            ...e.dataState,
            skip: e.dataState.skip,
            take: e.dataState.take
        });
        gridProps.onDataStateChange?.(e);
    };

    return (
        <Grid
            pageable={{ buttonCount: 3, pageSizes: [5, 10, 20, 50, 100], pageSizeValue: dataState.take }}
            scrollable="none"
            skip={dataState.skip}
            take={dataState.take}
            sort={dataState.sort}
            onPageChange={handlePageChange}
            onSortChange={handleSortChange}
            onDataStateChange={handleDataStateChange}
            {...gridProps}
        >
            {children}
        </Grid>
    );
};

export default AppGrid;
